import { render, staticRenderFns } from "./ProjectCreateUpdate.vue?vue&type=template&id=4e1391a0&scoped=true&"
import script from "./ProjectCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreateUpdate.vue?vue&type=style&index=0&id=4e1391a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1391a0",
  null
  
)

export default component.exports